import _store from "store2";
import {getCurrentTeamData, getTeamAllData} from "@/api/home";
import {objToArrays} from "@/utils/objToArrays";
import sessionStore from "@/utils/sessionStore";
import {readLocalStorageJSON} from "@/utils/json";

const countshow = {
        namespaced: true,
        state: {
            myEmailList: [],
            allEmailList: readLocalStorageJSON('sumData', []),
            getEmailListFlag: 0,
            sidebarTargetNumber: 0,
            sidbarNumbers: 0,
            teamSumDataLoading: false,
            teamSumDataLoadedTeamId: '',
        },
        mutations: {
            setEmailListFlag(state, payload) {
                state.getEmailListFlag = payload;
            },
            setSidebarTargetNumber(state, payload) {
                state.sidebarTargetNumber = payload
            },
            setSidbarNumbers(state, payload) {
                state.sidbarNumbers = payload;

            },
            setTeamSumDataLoading(state, payload) {
                state.teamSumDataLoading = !!payload
            },
            setTeamSumDataLoadedTeamId(state, payload) {
                state.teamSumDataLoadedTeamId = payload == null ? '' : String(payload)
            }
        },
        actions: {
            async getTeamAllDataApis({state}, payload = {}) {
                const teamId = payload?.teamId || sessionStore.get('teamId')
                if (!teamId) return

                try {
                    const res = await getCurrentTeamData({
                        teamId: teamId,
                    }, {errorPop: false})
                    if (res?.code !== 200) {
                        return false
                    }
                    const formatData = objToArrays(res?.result || {})
                    state.myEmailList = formatData
                    return true
                } catch (e) {
                    // 仪表盘计数属于辅助数据，失败时保留上次成功的结果。
                    return false
                }
            }
            ,
            async getTeamSumDataApis({state, commit}, payload = {}) {
                const teamId = payload?.teamId || sessionStore.get('teamId')
                if (!teamId) return

                commit('setTeamSumDataLoading', true)
                try {
                    const res = await getTeamAllData({
                        teamId: teamId,
                    }, {errorPop: false})
                    if (res?.code !== 200) {
                        return false;
                    }
                    const formatData = objToArrays(res?.result || {})
                    sessionStore.set('sumData', formatData)
                    try {
                        window.localStorage.setItem('sumData', JSON.stringify(formatData))
                    } catch (e) {
                    }
                    state.allEmailList = formatData;
                    commit('setTeamSumDataLoadedTeamId', teamId)
                    return true
                } catch (e) {
                    // 仪表盘计数属于辅助数据，失败时保留上次成功的结果。
                    return false
                } finally {
                    commit('setTeamSumDataLoading', false)
                }
            }
        },
    }
;

export default countshow;
